module.exports = __webpack_public_path__ + "s/img/Rainbow@2x.14f9a2ae.png";